var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Disconnect",
    transform: "translate(-788 -742)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    transform: "translate(788 742)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_20",
    "data-name": "Union 20",
    d: "M5183.536,22.8a1,1,0,0,1,0-1.415l1.485-1.484a5,5,0,0,1,.636-6.294l.708-.707-.354-.354a1,1,0,0,1,1.413-1.413l.354.354h0l-.353-.353a1,1,0,1,1,1.413-1.416l.354.355.708-.707a5,5,0,0,1,6.293-.637l1.485-1.485a1,1,0,1,1,1.415,1.415l-1.485,1.485a5,5,0,0,1-.636,6.292l-.708.709.355.354a1,1,0,1,1-1.415,1.413l-3.89-3.889,3.535,3.535h0l.354.354a1,1,0,1,1-1.415,1.413l-.354-.354-.707.707a5,5,0,0,1-6.292.637L5184.95,22.8a1,1,0,0,1-1.415,0Zm3.535-7.777a3,3,0,0,0-.023,4.219l.024.023.025.026a3,3,0,0,0,4.216-.026l.708-.707-4.242-4.242Zm4.243-4.242-.707.706,4.244,4.244.706-.707a3,3,0,0,0-4.242-4.242Z",
    transform: "translate(-4391.643 739.542)",
    fill: "#ebecff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.2a4143eb.svg";
export { ForwardRef as ReactComponent };